import React from 'react';
import { CloudRain, Coffee, Trees, Waves, Flame, Wind, Music, Music2, Power } from 'lucide-react';
import { WHITE_NOISE_SOUNDS, useTimerStore, type WhiteNoiseSettings } from '@flowfocus/core';
import { Switch } from './ui';

const ICONS: Record<string, typeof CloudRain> = {
  rain: CloudRain, cafe: Coffee, forest: Trees, ocean: Waves,
  fire: Flame, fan: Wind, brown: Music, pink: Music2,
};

export function WhiteNoisePanel() {
  const wn = useTimerStore((s) => s.settings.whiteNoise);
  const updateSettings = useTimerStore((s) => s.updateSettings);
  const apply = (next: WhiteNoiseSettings) => updateSettings({ whiteNoise: next });
  const activeCount = Object.values(wn.sounds).filter((v) => v > 0).length;

  return (
    <div>
      <div className="card" style={{ borderRadius: 12, marginBottom: 10, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '11px 14px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 30, height: 30, borderRadius: 8, background: 'var(--primary-soft)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Power size={15} color="var(--primary)" />
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 600 }}>Sonidos de fondo</div>
            <div style={{ fontSize: 12, color: 'var(--text-mut)' }}>{wn.enabled ? `${activeCount} activo${activeCount === 1 ? '' : 's'}` : 'Apagado'}</div>
          </div>
        </div>
        <Switch on={wn.enabled} onChange={(v) => apply({ ...wn, enabled: v })} />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, opacity: wn.enabled ? 1 : 0.45, pointerEvents: wn.enabled ? 'auto' : 'none' }}>
        {WHITE_NOISE_SOUNDS.map((s) => {
          const Icon = ICONS[s.id] ?? Music;
          const vol = wn.sounds[s.id] ?? 0;
          const active = vol > 0;
          return (
            <div key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '9px 4px' }}>
              <div style={{ width: 32, height: 32, borderRadius: 9, flexShrink: 0, background: active ? 'var(--primary-soft)' : 'var(--fill)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon size={16} color={active ? 'var(--primary)' : 'var(--text-mut)'} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 4 }}>{s.label}</div>
                <input type="range" className="ios" min={0} max={100} value={Math.round(vol * 100)}
                  style={{ width: '100%', accentColor: 'var(--primary)' }}
                  onChange={(e) => apply({ ...wn, enabled: true, sounds: { ...wn.sounds, [s.id]: Number(e.target.value) / 100 } })} />
              </div>
              <span style={{ width: 30, textAlign: 'right', fontSize: 11, color: 'var(--text-mut)' }}>{Math.round(vol * 100)}</span>
            </div>
          );
        })}
      </div>

      {activeCount > 0 && (
        <button className="btn-ghost" style={{ width: '100%', justifyContent: 'center', marginTop: 10, color: 'var(--primary)' }}
          onClick={() => apply({ enabled: false, sounds: {} })}>
          Detener todo
        </button>
      )}
    </div>
  );
}
